export default __webpack_public_path__ + "static/media/provider_8.b7165d92.png";